/**
 * newCaptureId.ts
 * -----------------------------------------------------------------
 * src/modules/timeline/services/capture/newCaptureId.ts
 *
 * ver1 - 29 October 2026 (Offline capture sync fix - Layer 4):
 *   One place that makes capture IDs. Used by QuickCaptureSheet (online
 *   captures) and localCaptureQueue (offline captures) so every capture
 *   carries the same kind of ID.
 *
 *   Always returns a valid version 4 UUID - the database column
 *   entries.client_capture_id is type uuid, so anything else would be
 *   refused forever.
 * -----------------------------------------------------------------
 */

export const CAPTURE_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function newCaptureId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function isValidCaptureId(value: string | null | undefined): value is string {
  return !!value && CAPTURE_ID_PATTERN.test(value);
}
